var _style, _g, _g2, _path, _g3, _path2, _g4, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "28 20 56 56",
    style: {
      enableBackground: "new 0 0 107.91 100.24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CC0031;}\n\t.st1{fill:#00BD75;}\n\t.st2{fill:#A4A4A4;}\n\t.st3{fill:#DADADA;}\n\t.st4{fill:#0F0742;}\n\t.st5{fill:#00683F;}\n\t.st6{fill:#8F0032;}\n\t.st7{font-family:'GeomGraphic-Bold';}\n\t.st8{font-size:3.6599px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.77,41.27 35.59,40.96 35.59,41.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.57,41.97 35.37,41.97 35.4,41.91 34.54,41.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.59,40.58 34.57,40.58 34.38,40.91 34.59,40.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.59,40.58 34.59,40.91 34.38,40.91 34.17,41.27 34.54,41.91 35.4,41.91 35.59,41.58 35.59,40.96 35.37,40.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "38.61,33.95 38.61,50.62 53.05,58.95 53.05,25.62  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "35.53,30.22 35.58,39.58 35.95,39.58 36.92,41.27 35.95,42.97 34,42.97 33.39,41.91 31.52,41.91 31.52,51.3 53,63.9 53,60.99 37.02,51.76 37.02,32.78 53,23.55 53,21.14 52.21,20.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.52,54.93 53,67.34 53,65.06 31.52,52.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.52,29.6 31.52,29.87 31.52,40.91 33.23,40.91 34,39.58 34.58,39.58 34.53,29.64 52.2,19.55 53,20 53,17.2 34.7,27.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "67.98,34.74 55,27.25 55,30.56 67.98,37.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "68.98,35.32 68.98,39.53 55,31.7 55,33.6 70.89,42.78 70.89,51.51 71.43,50.58 73.39,50.58 74.36,52.27 73.39,53.96 73.09,53.96 73.09,61.79 76.39,64.18 76.39,39.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "72.09,53.96 71.43,53.96 70.89,53.02 70.89,61.76 55,70.93 55,74.49 55,77.28 76.03,65.14 72.09,62.31  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "30.77,28.88 30.52,29.02 30.52,30.53 30.52,40.91 31.02,40.91 31.52,40.91 31.52,29.87 31.52,29.6 34.7,27.77 53,17.2 53,16.62 53,16.04 46.28,19.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31.52,52.46 31.02,52.17 30.52,51.87 30.52,55.51 53,68.49 53,67.92 53,67.34 31.52,54.93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "31.52,51.3 31.52,41.91 31.02,41.91 30.52,41.91 30.52,50.71 31.02,51.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "68.98,34.17 68.98,34.75 68.98,35.32 76.39,39.6 76.39,64.18 76.89,64.54 77.39,64.9 77.39,39.02 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "76.03,65.14 55,77.28 55,77.86 55,78.44 76.92,65.79 76.47,65.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "67.98,34.17 67.98,33.59 55,26.1 55,26.68 55,27.25 67.98,34.74  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.81,51.58 72.01,51.58 71.9,51.77 72.92,51.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "73.21,52.27 73.09,52.06 73.09,52.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.09,52.96 72.09,52.77 71.9,52.77 72.01,52.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.09,52.96 72.81,52.96 73.09,52.48 73.09,52.06 72.92,51.77 71.9,51.77 71.61,52.27 71.9,52.77 72.09,52.77  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M34.53,29.64l0.05,9.94H34l-0.77,1.33h-1.71h-0.5h-0.5v1h0.5h0.5h1.87L34,42.97h1.95l0.98-1.69l-0.98-1.69 h-0.37l-0.05-9.36l16.68-9.52l0.8,0.45V20l-0.8-0.45L34.53,29.64z M35.59,41.58l-0.19,0.33l-0.03,0.05h-0.8l-0.03-0.05l-0.37-0.64 l0.21-0.36l0.19-0.33h0.01h0.78l0.22,0.38l0.18,0.31L35.59,41.58z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "31.02,51.01 30.52,50.71 30.52,51.87 31.02,52.17 31.52,52.46 53,65.06 53,63.9 31.52,51.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "67.98,34.17 67.98,34.74 67.98,37.83 55,30.56 55,31.7 68.98,39.53 68.98,35.32 68.98,34.75 68.98,34.17 67.98,33.59  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.89,64.54l-0.5-0.36l-3.3-2.38v-7.83h0.3l0.98-1.69l-0.98-1.69h-1.95l-0.54,0.94l-0.15,0.25h0.15v1h-0.15 l0.15,0.25l0.54,0.94h0.66v8.35l3.94,2.84l0.45,0.32l0.44,0.32l0.23-0.13l0.25-0.14V64.9L76.89,64.54z M71.9,52.77l-0.29-0.5 l0.29-0.5l0.11-0.19h0.8l0.11,0.19l0.17,0.29l0.12,0.21l-0.12,0.21l-0.28,0.48h-0.72h-0.08L71.9,52.77z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "69.48,60.62 69.48,43.95 55.04,35.62 55.04,68.95  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45.28,48.57v-2.2c-1.92-0.25-3.43-1.76-3.66-3.69H39.4v-1.1h2.23c0.26-1.89,1.76-3.39,3.66-3.63V35.7h1.1v2.25 c1.9,0.24,3.4,1.74,3.66,3.63h2.23v1.1h-2.22c-0.23,1.92-1.74,3.44-3.66,3.69v2.2H45.28z M42.73,42.69c0.11,0.64,0.41,1.24,0.88,1.7 c0.46,0.46,1.04,0.76,1.68,0.87v-0.91l0.37,0.05c0.06,0.01,0.12,0.01,0.18,0.01s0.12,0,0.18-0.01l0.37-0.05v0.91 c0.63-0.11,1.22-0.41,1.68-0.87c0.47-0.47,0.77-1.06,0.88-1.7h-0.9l0.05-0.37c0.01-0.05,0.01-0.1,0.01-0.16 c0-0.07-0.01-0.13-0.02-0.2l-0.06-0.38h0.92c-0.12-0.62-0.42-1.2-0.87-1.65c-0.46-0.46-1.04-0.76-1.68-0.87v0.91l-0.37-0.05 c-0.06-0.01-0.12-0.01-0.18-0.01s-0.12,0-0.18,0.01l-0.37,0.05v-0.91c-0.63,0.11-1.22,0.41-1.68,0.87 c-0.45,0.45-0.75,1.03-0.87,1.65h0.91l-0.06,0.38c-0.01,0.07-0.02,0.13-0.02,0.2c0,0.05,0,0.1,0.01,0.16l0.05,0.37H42.73z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M46.13,40.55v1.33h1.27v0.57h-1.27v1.34h-0.6v-1.34h-1.27v-0.57h1.27v-1.33H46.13z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M61.71,58.5v-2.2c-1.92-0.25-3.43-1.76-3.66-3.69h-2.22v-1.1h2.23c0.26-1.89,1.76-3.39,3.66-3.63v-2.25h1.1 v2.25c1.9,0.24,3.4,1.74,3.66,3.63h2.23v1.1h-2.22c-0.23,1.92-1.74,3.44-3.66,3.69v2.2H61.71z M59.16,52.61 c0.11,0.64,0.41,1.24,0.88,1.7c0.46,0.46,1.04,0.76,1.68,0.87v-0.91l0.37,0.05c0.06,0.01,0.12,0.01,0.18,0.01 c0.06,0,0.12,0,0.18-0.01l0.37-0.05v0.91c0.63-0.11,1.22-0.41,1.68-0.87c0.47-0.47,0.77-1.06,0.88-1.7h-0.9l0.05-0.37 c0.01-0.05,0.01-0.1,0.01-0.16c0-0.07-0.01-0.13-0.02-0.2l-0.06-0.38h0.92c-0.12-0.62-0.42-1.2-0.87-1.65 c-0.46-0.46-1.04-0.76-1.68-0.87v0.91l-0.37-0.05c-0.06-0.01-0.12-0.01-0.18-0.01c-0.06,0-0.12,0-0.18,0.01l-0.37,0.05v-0.91 c-0.63,0.11-1.22,0.41-1.68,0.87c-0.45,0.45-0.75,1.03-0.87,1.65h0.91l-0.06,0.38c-0.01,0.07-0.02,0.13-0.02,0.2 c0,0.05,0,0.1,0.01,0.16l0.05,0.37H59.16z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M63.83,51.66v0.84h-3.14v-0.84H63.83z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 45.8314 33.4488)",
    className: "st5 st7 st8"
  }, "+5")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 55.9539 64.3349)",
    className: "st6 st7 st8"
  }, "-5")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKills);
export default __webpack_public_path__ + "static/media/kills.2541129cbe0f3f044356bc16c128eaaa.svg";
export { ForwardRef as ReactComponent };